import { IServerMessage } from './IServerSentEventsConsumer';

export class ServerMessage implements IServerMessage {
    private eventType?: string;
    private id?: string;
    private data: string[] = [];

    constructor(private message: string) {
        this.parseMessage();
    }

    private parseMessage(): void {
        const lines = this.message.split('\n');
        lines.forEach(line => {
            const [key, ...value] = line.split(':');
            const trimmedKey = key.trim();
            const trimmedValue = value.join(':').trim();

            switch (trimmedKey) {
                case 'event':
                    this.eventType = trimmedValue;
                    break;
                case 'id':
                    this.id = trimmedValue;
                    break;
                case 'data':
                    this.data.push(trimmedValue);
                    break;
                default:
                    console.error(`ServerMessage::parseMessage - Unknown key: ${trimmedKey} with value: ${trimmedValue}`);
                    break;
            }
        });
    }

    getRawMessage(): string {
        return this.message;
    }

    getEventType(): string | undefined {
        return this.eventType;
    }

    getId(): string | undefined {
        return this.id;
    }

    getJsonData<T>(): T[] {
        let returnData: T[] = [];
        if (this.data) {
            returnData = this.data.map(item => JSON.parse(item)) as T[];
        }
        return returnData;
    }
}
